import { Grid, Typography, CircularProgress } from "@mui/material";
import ProjectCard from "./ProjectCard";
import { useContext, useEffect } from "react";
import { ProjectContext } from "../../../contexts/ProjectContext";

export default function ProjectList({ projects, categoryProjects, categoryName, categoryId }) {
  const { fetchCategory, fetchProjects } = useContext(ProjectContext);
  useEffect(() => {
    fetchCategory();
    fetchProjects();
  }, []);
  const isLoading = !Array.isArray(projects);
  const filteredProjects = Array.isArray(projects)
    ? projects.filter((project) =>
        categoryProjects.includes(project?.projectId)
      )
    : [];

  return (
    <Grid container spacing={8} mb={2}>
      {isLoading ? (
        <Grid item xs={12}>
          <CircularProgress color="inherit" />
        </Grid>
      ) : filteredProjects.length > 0 ? (
        filteredProjects.map((project, index) => (
          <Grid key={project.projectId} item xs={12} sm={6} md={3}>
            <ProjectCard
              categoryName={categoryName}
              categoryId={categoryId}
              project={project}
              index={index}
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant={"h6"}>No Projects Found</Typography>
        </Grid>
      )}
    </Grid>
  );
}
